import React, { useEffect } from "react";
import { useLocation, useNavigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginPage from "./Components/AuthPage/LoginPage";
import HomePage from "./Components/HomePage/HomePage";
import EodAnalytics from "./Components/HomePage/EodAnalytics";
import EodReports from "./Components/HomePage/EODReports";
import TSH from "./Components/HomePage/TSH";
import IntradayAnalytics from "./Components/HomePage/IntradayAnalytics";
import { validateAuthToken } from "./Utilities/Url";

function MainApp() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const dispatch = useDispatch();
  useEffect(() => {
    let token = localStorage.getItem("token");

    if (token) {
      token = token.replace(/['"]+/g, "");
      dispatch({ type: "SET_AUTHTOKEN", payload: token });
      dispatch({ type: "SET_ISAUTHENTICATED", payload: true });
      navigate("/homepage");
      return;
    }
    const searchParams = new URLSearchParams(location.search);
    const currentToken = searchParams.get("accesstoken");
    if (!currentToken) {
      navigate("/login");
    } else {
      validateAuthToken(dispatch, currentToken)
        .then((val) => {
          if (val) {
            localStorage.setItem("token", JSON.stringify(currentToken));
            dispatch({
              type: "SET_AUTHTOKEN",
              payload: currentToken,
            });
            dispatch({ type: "SET_ISAUTHENTICATED", payload: true });
            navigate("/homepage");
          } else {
            localStorage.removeItem("token");
            navigate("/login");
          }
        })
        .catch((err) => {
          localStorage.removeItem("token");
          navigate("/login");
        });
    }
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {isAuthenticated && (
        <>
          <Route path="/homepage" element={<HomePage />} />
          <Route path="/eod-analytics" element={<EodAnalytics />} />
          <Route path="/intraday-analytics" element={<IntradayAnalytics />} />
          <Route path="/eod-reports" element={<EodReports />} />
          <Route path="/tsh" element={<TSH />} />
        </>
      )}
    </Routes>
  );
}

export default MainApp;
